module.exports = __webpack_public_path__ + "assets/img/花.8516474b.png";